import { FC } from "react";
import { Box, Theme } from "@mui/material";
import { Formik, FormikHelpers } from "formik";
import InnerForm from "./children/InnerForm";
import { Modal, ModalProps } from "@vilocnv/allsetra-core";
import {
  reportsTagFilterFormInitialValues,
  reportsTagFilterFormValidationSchema
} from "app/data/helpers";
import { getResetFilterFormValues } from "app/data/helpers/ReportHelpers";
import { useTranslation } from "react-i18next";

export type TagFilterFormProps = Pick<ModalProps, "open" | "onClose"> & {
  onSubmit: (values: any, formikHelpers: FormikHelpers<any>) => void;
  theme: Theme;
  dataLoading?: boolean;
  groups: Array<any>;
  objectTypes: Array<any>;
  objects: Array<any>;
  submitting?: boolean;
  fetchOnDebounce: (value: string) => void;
  onChange?: (val?: any) => void;
  isReportsHistoryPage?: boolean;
  formInitialValues?: Record<string, any>;
  formValidations?: {};
  onResetFilters?: () => void;
};

const TagFilterForm: FC<TagFilterFormProps> = ({
  open,
  onClose,
  onSubmit,
  theme,
  dataLoading = false,
  groups,
  objects,
  objectTypes,
  submitting = false,
  fetchOnDebounce,
  onChange,
  isReportsHistoryPage = false,
  formInitialValues = reportsTagFilterFormInitialValues,
  formValidations = reportsTagFilterFormValidationSchema,
  onResetFilters
}) => {
  const { t } = useTranslation(["translation", "formFieldsTranslation"]);

  return (
    <Formik
      initialValues={formInitialValues}
      validationSchema={formValidations}
      onSubmit={onSubmit}
      enableReinitialize
      validateOnMount
    >
      {({
        handleSubmit,
        isSubmitting,
        isValid,
        resetForm,
        values,
        setFieldValue
      }) => (
        <Modal
          open={open}
          onClose={() => {
            resetForm();
            onClose();
          }}
          title="Filters"
          primaryBtnProps={{
            type: "submit",
            text: t("buttonsText.apply"),
            loading: isSubmitting || submitting,
            // @ts-ignore
            onClick: handleSubmit,
            disabled: !isValid
          }}
          secondaryBtnProps={{
            text: t("buttonsText.cancel"),
            onClick: onClose
          }}
          theme={theme}
          size="customSize"
        >
          <>
            <InnerForm
              groups={groups}
              objectTypes={objectTypes}
              objects={objects}
              dataLoading={dataLoading}
              translator={t}
              fetchOnDebounce={fetchOnDebounce}
              onChange={onChange}
              isReportsHistoryPage={isReportsHistoryPage}
              values={values}
              setFieldValue={setFieldValue}
            />
            <Box mt={2} display="flex" justifyContent="flex-start">
              <button
                type="button"
                onClick={() => {
                  const resetValues = getResetFilterFormValues(
                    formInitialValues as Record<string, any>
                  );
                  resetForm({ values: resetValues });
                  onChange?.([]);
                  onResetFilters?.();
                  fetchOnDebounce("");
                }}
                style={{
                  background: "transparent",
                  border: "none",
                  color: theme.palette.primary.main,
                  cursor: "pointer",
                  textDecoration: "underline",
                  fontSize: 14,
                  padding: 0
                }}
              >
                {t("buttonsText.reset", { defaultValue: "Reset filters" })}
              </button>
            </Box>
          </>
        </Modal>
      )}
    </Formik>
  );
};

export default TagFilterForm;
